(() => {
  const accordionLabels = [
    /^WIRKUNG:?$/i,
    /^DADURCH:?$/i,
    /^ANWENDUNG WERKSTATT STANDARD:?$/i,
    /^EMPFOHLENE ANWENDUNG:?$/i,
    /^DOSIERUNG:?$/i
  ];
  const safetyLabel = /^GEFAHR\s*:/i;
  const dashAttributeNames = ['aria-label', 'alt', 'placeholder', 'title'];

  function removeEnDashes(scope) {
    if (!scope) return;

    const replaceTextNode = (node) => {
      const parentTag = node.parentElement?.tagName;
      if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'TEXTAREA'].includes(parentTag)) return;
      if (node.nodeValue?.includes('–')) node.nodeValue = node.nodeValue.replaceAll('–', '-');
    };

    if (scope.nodeType === Node.TEXT_NODE) {
      replaceTextNode(scope);
      return;
    }

    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      replaceTextNode(textNode);
      textNode = walker.nextNode();
    }

    if (scope.nodeType === Node.ELEMENT_NODE) {
      [scope, ...scope.querySelectorAll('*')].forEach((element) => {
        dashAttributeNames.forEach((attributeName) => {
          const value = element.getAttribute(attributeName);
          if (value?.includes('–')) element.setAttribute(attributeName, value.replaceAll('–', '-'));
        });
      });
    }
  }

  function normalizedText(node) {
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function enhanceDescription(root) {
    if (!root || root.dataset.eurosolAccordion === 'true') return;

    const nodes = Array.from(root.childNodes);
    const intro = [];
    const groups = [];
    const safety = [];
    let current = null;
    let inSafety = false;

    nodes.forEach((node) => {
      const text = normalizedText(node);
      if (!text && node.nodeType === Node.TEXT_NODE) return;

      if (safetyLabel.test(text)) {
        inSafety = true;
        current = null;
        safety.push(node);
        return;
      }

      const leadingStrong = node.nodeType === Node.ELEMENT_NODE && node.firstElementChild?.tagName === 'STRONG'
        ? node.firstElementChild
        : null;
      const leadingLabel = leadingStrong ? normalizedText(leadingStrong) : '';
      const hasEmbeddedLabel = accordionLabels.some((pattern) => pattern.test(leadingLabel));

      if (hasEmbeddedLabel && !inSafety) {
        current = { label: leadingLabel, nodes: [] };
        groups.push(current);
        leadingStrong.remove();

        while (node.firstChild && (
          node.firstChild.nodeName === 'BR' ||
          (node.firstChild.nodeType === Node.TEXT_NODE && !normalizedText(node.firstChild))
        )) {
          node.firstChild.remove();
        }

        if (normalizedText(node)) current.nodes.push(node);
        return;
      }

      const isLabel = accordionLabels.some((pattern) => pattern.test(text));
      if (isLabel && !inSafety) {
        current = { label: text, nodes: [] };
        groups.push(current);
        return;
      }

      if (inSafety) safety.push(node);
      else if (current) current.nodes.push(node);
      else intro.push(node);
    });

    if (groups.length < 2) return;

    const fragment = document.createDocumentFragment();
    intro.forEach((node) => fragment.appendChild(node));

    const accordion = document.createElement('div');
    accordion.className = 'eurosol-description-accordion';

    groups.forEach((group, index) => {
      const details = document.createElement('details');
      if (index === 0) details.open = true;

      const summary = document.createElement('summary');
      summary.textContent = group.label;
      details.appendChild(summary);

      const content = document.createElement('div');
      content.className = 'eurosol-description-accordion__content';
      group.nodes.forEach((node) => content.appendChild(node));
      details.appendChild(content);
      accordion.appendChild(details);
    });

    fragment.appendChild(accordion);

    if (safety.length) {
      const safetyBlock = document.createElement('div');
      safetyBlock.className = 'eurosol-description-safety';
      safety.forEach((node) => safetyBlock.appendChild(node));
      fragment.appendChild(safetyBlock);
    }

    root.replaceChildren(fragment);
    root.classList.add('is-eurosol-accordion');
    root.dataset.eurosolAccordion = 'true';
  }

  function initTracking(scope = document) {
    const selectors = [
      '[data-eurosol-track]',
      '.slideshow a.button',
      '.eurosol-application',
      '.eurosol-product-hub a[href*="/products/"]',
      '.eurosol-fill-x-clean a',
      '.eurosol-product-guidance a',
      '.product-form__submit',
      '.cart__checkout-button',
      '.mini-cart button[name="checkout"]'
    ].join(',');

    scope.querySelectorAll(selectors).forEach((element) => {
      if (element.dataset.eurosolTrackingBound === 'true') return;
      element.dataset.eurosolTrackingBound = 'true';

      element.addEventListener('click', () => {
        const action = element.dataset.eurosolTrack
          || (element.matches('.product-form__submit') ? 'add-to-cart' : '')
          || (element.matches('[name="checkout"], .cart__checkout-button') ? 'checkout' : '')
          || (element.closest('.slideshow') ? 'hero-click' : '')
          || (element.classList.contains('eurosol-application') ? 'application-click' : '')
          || 'content-click';
        const detail = {
          action,
          label: normalizedText(element).slice(0, 120),
          path: element.getAttribute('href') || window.location.pathname
        };

        window.dispatchEvent(new CustomEvent('eurosol:cro-interaction', { detail }));
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: 'eurosol_cro_interaction', ...detail });
        }
      }, { passive: true });
    });

    scope.querySelectorAll('.faq details, .eurosol-product-guidance__details').forEach((details) => {
      if (details.dataset.eurosolTrackingBound === 'true') return;
      details.dataset.eurosolTrackingBound = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        const summary = details.querySelector('summary');
        const detail = {
          action: 'answer-open',
          label: summary ? summary.textContent.trim() : '',
          path: window.location.pathname
        };
        window.dispatchEvent(new CustomEvent('eurosol:cro-interaction', { detail }));
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: 'eurosol_cro_interaction', ...detail });
        }
      });
    });
  }

  function initProductCompare(scope = document) {
    scope.querySelectorAll('[data-eurosol-product-matrix]').forEach((matrix) => {
      if (matrix.dataset.eurosolMatrixBound === 'true') return;
      matrix.dataset.eurosolMatrixBound = 'true';

      const activate = (target) => {
        const cell = target.closest('[data-product-column]');
        if (!cell || !matrix.contains(cell)) return;
        matrix.dataset.activeProduct = cell.dataset.productColumn;
      };

      matrix.addEventListener('pointerover', (event) => activate(event.target));
      matrix.addEventListener('pointerdown', (event) => activate(event.target));
      matrix.addEventListener('click', (event) => activate(event.target));
      matrix.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') delete matrix.dataset.activeProduct;
      });
      matrix.addEventListener('focusin', (event) => activate(event.target));
      matrix.addEventListener('focusout', (event) => {
        if (!matrix.contains(event.relatedTarget)) delete matrix.dataset.activeProduct;
      });
    });
  }

  function init(scope = document) {
    removeEnDashes(scope);
    scope.querySelectorAll('.product__description.rte').forEach(enhanceDescription);
    initTracking(scope);
    initProductCompare(scope);
  }

  const dashObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') removeEnDashes(mutation.target);
      mutation.addedNodes.forEach(removeEnDashes);
    });
  });

  function start() {
    init();
    dashObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
